import { Card, Form, Flex, Input } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

const ContactCard = () => {
  const themeDefault = useSelector((state) => state.themeDefault);

  return (
    <Card
      bordered
      title="Contact"
      style={{
        height: 338,
      }}>
      <Flex
        gap={8}
        vertical
        style={{
          borderTop: themeDefault?.info?.newConfig?.cardborder,
          paddingTop: 16,
          marginTop: -16,
        }}>
        <Flex gap={16} wrap="wrap">
          {/* Personal Email */}
          <Form.Item
            name="personalEmail"
            label="Personal Email"
            rules={[{ required: true, message: "Personal Email is required" }]}
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}>
            <Input placeholder="Enter Personal Email" />
          </Form.Item>
          {/* Personal Mobile */}
          <Form.Item
            name="perPhoneNo"
            label="Personal Mobile"
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
            rules={[
              { required: true, message: "Personal Mobile is required" },
              {
                validator: (_, value) => {
                  if (!value || isValidPhoneNumber(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Enter a valid phone number")
                  );
                },
              },
            ]}>
            <PhoneInput
              defaultCountry="AE" // Default to UAE (+971)
              placeholder="Enter Personal Mobile"
              international
              countryCallingCodeEditable={true}
            />
          </Form.Item>
        </Flex>

        <Flex gap={16} wrap="wrap">
          {/* Work Email */}
          <Form.Item
            name="workEmail"
            label="Work Email"
            style={{ flex: 1, minWidth: 220, marginBottom: 0 }}>
            <Input placeholder="Enter Work Email" />
          </Form.Item>

          {/* Work Mobile */}
          <Form.Item
            name="workMobile"
            label="Work Mobile"
            style={{ flex: 1, minWidth: 220, marginBottom: 0 }}>
            <PhoneInput
              defaultCountry="AE"
              placeholder="Enter Work Mobile"
              international
              countryCallingCodeEditable={true}
            />
          </Form.Item>
        </Flex>
      </Flex>
    </Card>
  );
};

export default ContactCard;
